// styles.ts
import styled from 'styled-components';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import LogoEckenmoorhexen from "../../../../assets/images/LogoEckenmoorhexen.png";
import BurgerMenuBackground from "../../../../assets/images/burgerMenu.png";
import { COLORS } from '../../../../values/colors';
import { Close } from '@mui/icons-material';

export const Container = styled.div`
    height: 3rem;
    width: 100vw;
    position: fixed;
    padding: 2rem 0;
    top: 0;
    z-index: 5;
    background-color: ${COLORS.darkdarkGray};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const FullWidthDrawer = styled(Drawer)`
    .MuiDrawer-paper {
        width: 100%;
        background-color: ${COLORS.darkdarkGray};
        background-image: linear-gradient(rgba(0, 0, 0, 0.62), rgba(0, 0, 0, 0.62)), url(${BurgerMenuBackground});
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        padding-top: 1rem;
    }
`;

export const StyledListItem = styled(ListItem)`
    padding: 1rem;
    &:hover {
        color: ${COLORS.textSecondary};
    }
    color: white;
`;

export const MenuButton = styled(Button)`
    z-index: 3;
    min-width: auto !important;
`;

export const StyledMenuIcon = styled(MenuIcon)`
    color: white !important;
    font-size: 2.5rem !important;
`;

export const LogoContainer = styled.div`
    width: 5rem;
    height: 5rem;
    background-image: url(${LogoEckenmoorhexen});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    margin-left: 1.5rem;
`;

export const CloseButtonWrapper = styled.div`
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 4;
`;

export const CloseButton = styled(Button)`
`;

export const StyledCloseIcon = styled(Close)`
    color: white !important;
    font-size: 2.5rem !important;
`;

export const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-right: 1rem;
`;
